import configs from './config/urlConfigs';
export function generatePreSignedGetUrl(fileName, fileType) {
    if (!fileName || typeof fileName !== 'string') return "";
    return `${configs.BACKEND_API_URL}/ee/get-presigned-get-url?fileName=${encodeURIComponent(fileName)}`;
}

// exports.generatePreSignedGetUrl = generatePreSignedGetUrl;
// exports.generatePreSignedPutUrl = generatePreSignedPutUrl;

